"use client";

import React from "react";
import { currentPageUrl } from "../../services/page-url";
import { fireLinkClick } from "../../services/analytics";
import { withSafeRender } from "../../atoms/safe-render";

/** The reported name. Never the digits — the number is not a dimension. */
export const PHONE_LINK_NAME = "phone number: call us";

export interface NavPhoneLinkProps {
  /** The `tel:` href. */
  href: string;
  /** Placement the click reports under. Absent, the click reports nothing. */
  linkPosition?: string;
  children: React.ReactNode;
}

/**
 * ⚠ No `data-linkposition` or `data-linkdestination` here: the container would
 * name the click from the digits and report it twice. The click dials rather
 * than navigates, so the destination is the page itself.
 */
function NavPhoneLinkImpl({ href, linkPosition, children }: NavPhoneLinkProps) {
  const report = () => {
    if (linkPosition) {
      fireLinkClick({
        linkName: PHONE_LINK_NAME,
        linkPosition,
        linkDestination: currentPageUrl()
      });
    }
  };

  return (
    <a href={href} onClick={report}>
      {children}
    </a>
  );
}
export const NavPhoneLink = withSafeRender(NavPhoneLinkImpl, "NavPhoneLink");

export default NavPhoneLink;
